import { useEffect, useState } from 'react'

import Action from 'ageas-react-component-action'
import Modal from 'ageas-react-component-modal'
import PageTitle from 'ageas-react-component-pagetitle'

import { MainContainer } from '../../GlobalStyles'
import { useAnimalValidateStore } from '../../Stores/useAnimalValidateStore'
import { Question, QuestionsBlock } from '../../Types/AnimalStore'
import { t } from '../../i18n'
import { concatenateObjectValuesWithComma } from '../../utils/address'
import { Disclaimer } from '../Disclaimer'
import { ModalComponent } from '../ModalComponent'
import {
  AddressForm,
  initialFormAddressValues,
} from '../OwnerData/components/AddressForm'
import { Container } from '../SelectedEntity/styles'
import { ButtonGroup } from './styles'

export const orderAnimalAddress = [
  'entityTypeArteria',
  'entityNameArteria',
  'entityNumberPolice',
  'entityFloor',
  'entityNumberDoor',
  'entityComplement',
  'entityZipCode',
  'entityLocalization',
]

type Props = {
  isVisible: boolean
  isResetState: boolean
  animalId: string | number
  declaration: QuestionsBlock
  questionPM: Question
  changeValue: (
    declarationId: number | string,
    itemId: number | string,
    value: string,
  ) => void
  closeAction?: () => void
}

export function CreateAddress({
  isVisible,
  animalId,
  declaration,
  questionPM,
  changeValue,
  isResetState,
  closeAction = () => {},
}: Props) {
  const { addressOwner, setAddressOwner, setAddressZipCodeSelected } =
    useAnimalValidateStore()
  const [formValues, setFormValues] = useState(
    addressOwner?.[`address-${animalId}`] || initialFormAddressValues,
  )

  const handleAddAddress = () => {
    changeValue(
      declaration.id,
      questionPM.id,
      concatenateObjectValuesWithComma(formValues as never, orderAnimalAddress),
    )
    setAddressOwner({
      [`address-${animalId}`]: formValues,
    })
  }

  useEffect(() => {
    if (isResetState) {
      setFormValues(initialFormAddressValues)
    }
  }, [isResetState])

  return (
    <ModalComponent show={isVisible}>
      <Modal
        show={isVisible}
        hideCloseAction={false}
        closeAction={closeAction}
        content={
          <MainContainer>
            <Container>
              <PageTitle
                id="anima-create-address"
                name={t('pages.step1.createAddress.ownerAddress')}
              />
              <AddressForm
                hiddenTitle
                isAnimal
                initialFormValues={formValues}
                onChange={(values) => setFormValues(values)}
                onAddressSelected={(values) =>
                  setAddressZipCodeSelected(values)
                }
              />
              <Disclaimer text={t('addressSelectTable.disclaimerInfo')} />
              <Disclaimer text={t('addressSelectTable.disclaimerFont')} />
              <ButtonGroup>
                <Action
                  id="cancel-create"
                  label={t('general.cancel')}
                  buttonType="secondary"
                  type="button"
                  onValueChanged={() => {
                    if (
                      (
                        addressOwner?.[`address-${animalId}`]?.entityZipCode ||
                        ''
                      )?.length === 0
                    ) {
                      setFormValues(initialFormAddressValues)
                      setAddressZipCodeSelected(null)
                    }
                    closeAction()
                  }}
                />

                <Action
                  id="submit-create"
                  label={t('pages.step1.createAddress.confirm')}
                  type="button"
                  disable={
                    (formValues?.entityZipCode || '')?.length === 0 ||
                    (formValues?.entityLocalization || '')?.length === 0
                  }
                  onValueChanged={() => {
                    handleAddAddress()
                    closeAction()
                  }}
                />
              </ButtonGroup>
            </Container>
          </MainContainer>
        }
      />
    </ModalComponent>
  )
}
